// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TypeUtils = require("../TypeUtils.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var fromString = include.fromString;

var toString = include.toString;

var decode = include.decode;

var encode = include.encode;

var compare = include.compare;

var eq = include.eq;

var Ord = include.Ord;

var $$Set = include.$$Set;

var $$Map = include.$$Map;

exports.fromString = fromString;
exports.toString = toString;
exports.decode = decode;
exports.encode = encode;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.$$Map = $$Map;
/* include Not a pure module */
